import apiCrud from '../../abstract/api-crud';
import apiPaths from '../../../../api-v2/api-paths';

const baseUri = `${ apiPaths.CRM }/mail-templates`;
export const modelName = 'mail-templates';

export default {
  ...apiCrud({ baseUri, modelName }),
};
